import { render } from "./CompanySelector.vue?vue&type=template&id=20e25c28&scoped=true"
import script from "./CompanySelector.vue?vue&type=script&lang=js"
export * from "./CompanySelector.vue?vue&type=script&lang=js"

import "./CompanySelector.vue?vue&type=style&index=0&id=20e25c28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e25c28"]])

export default __exports__